import { useRecoilValue, useSetRecoilState } from "recoil"
import { useInterval } from "../../hooks/useInterval";
import { coPiWithoutRelationState, getUnlinkedCopilot } from "../../store/CopilotListState";
import { userState } from "../../store/UserState"

const CoPiWithoutRelationObserver = () => {
  const customer = useRecoilValue(userState).customer;
  const setCoPiWithoutRelation = useSetRecoilState(coPiWithoutRelationState);

  useInterval(async () => {
    const data = await getUnlinkedCopilot(customer);
    setCoPiWithoutRelation(data);
  }, 30000, true);

  return null;
}

export default CoPiWithoutRelationObserver;
